import { PayloadAction } from "@reduxjs/toolkit";

import { LIS } from "shared/actions/constants";

import { ACCESSION_CASE_SUCCESS } from "app/actions/caseActions";
import { SPECIMEN_BAG_SCAN } from "app/constants";
import { BarcodeObject } from "util/objectFromBarcode";

type SpecimenBagState =
  | {
      barcode?: BarcodeObject;
    }
  | undefined;

const initialState = {
  barcode: undefined,
};

const specimenBagReducer = (
  state: SpecimenBagState = initialState,
  action: PayloadAction<BarcodeObject | undefined>
): SpecimenBagState => {
  switch (action.type) {
    case SPECIMEN_BAG_SCAN:
      return {
        barcode: action.payload,
      };
    case ACCESSION_CASE_SUCCESS:
      return initialState;
    case LIS.ACCESSION.CREATE.SUCCESS:
      return initialState;
    default:
      return state;
  }
};
export default specimenBagReducer;
